import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, limit, orderBy, query, serverTimestamp } from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';
import type { IOpportunityService, IOpportunityState } from '../OpportunityService';
import { firestoreDB } from './config';

export default class FireServiceAdapter implements IOpportunityService {
  async saveOpportunity(params: any): Promise<{ id: string }> {
    const opportunityId = uuidv4();
    const ts = serverTimestamp();
    const opportunityInfo = {
      ID: opportunityId,
      createdAt: ts,
      ...params.opportunityInfo,
      projectTeam: params.projectTeam,
      preliminaryProgram: params.preliminaryProgram,
      projectUses: params.projectUses,
      mileStoneSchedule: params.mileStoneSchedule,
      vendor: params.vendor,
      incentive: {},
    };
    // await this.collectionPostRequest("opportunity", opportunityInfo);
    const opportunityColRef = collection(firestoreDB, 'opportunity');
    await addDoc(opportunityColRef, opportunityInfo);

    return {
      id: opportunityInfo.ID,
    };
  }

  async fetchOpportunity(docId: string): Promise<IOpportunityState> {
    const opportunityState = {} as IOpportunityState;
    const opportunity = await this.collectionFindByIDRequest('opportunity', docId);
    opportunityState.opportunityInfo = {
      ID: opportunity.ID,
      docId: opportunity.docId,
      projectName: opportunity.projectName,
      address: opportunity.address ? opportunity.address : 'unknown street',
      market: opportunity.market ? opportunity.market : 'Chicago',
      subMarket: opportunity.subMarket ? opportunity.subMarket : 'IL',
      projectType: opportunity.projectType,
      constructionType: opportunity.constructionType,
      procurementType: opportunity.procurementType,
      sourcingDocument: opportunity.sourcingDocument,
      developmentPartner: opportunity.developmentPartner,
      squareFeet: opportunity.squareFeet,
    };
    opportunityState.preliminaryProgram = opportunity.preliminaryProgram;
    opportunityState.projectUses = opportunity.projectUses;
    opportunityState.projectSource = opportunity.projectSource;
    opportunityState.milestoneSchedule = opportunity.milestoneSchedule;
    opportunityState.projectTeam = opportunity.projectTeam;
    opportunityState.vendor = opportunity.vendor;
    opportunityState.incentives = opportunity.incentives;
    return opportunityState;
  }

  async listOpportunities(): Promise<IOpportunityState[]> {
    const opportunities = await this.collectionAll('opportunity');
    return opportunities.map(
      (p: any) =>
        ({
          opportunityInfo: {
            docId: p.docId,
            ID: p.ID,
            name: p.projectName,
            address: p.address ? p.address : 'unknown street',
            market: p.market ? p.market : 'Chicago',
            subMarket: p.subMarket ? p.subMarket : 'IL',
            constructionType: p.constructionType,
            procurementType: p.procurementType,
            projectType: p.projectType,
            developmentPartner: p.developmentPartner,
            squareFeet: p.squareFeet,
            sourcingDocument: p.sourcingDocument,
            state: p.preliminaryProgram.state,
            zipCode: p.preliminaryProgram.zipCode,
            city: p.preliminaryProgram.city,
          },
        }) as IOpportunityState
    );
  }

  async deleteOpportunity(docId: string): Promise<void> {
    const docRef = doc(firestoreDB, 'opportunities', docId);
    await deleteDoc(docRef);
    // await this.documentDeleteRequest("opportunities", id);
  }

  // async documentDeleteRequest(collection: string, id: string) {
  //   const ref = await fireStoreDB.collection(collection).where("ID", "==", id);
  //   ref.get().then(function (querySnapshot) {
  //     querySnapshot.forEach(function (doc) {
  //       doc.ref.delete();
  //     });
  //   });
  // }

  async documentDeleteRequestByOpportunityID(col: string, docId: string) {
    const docRef = doc(firestoreDB, col, docId);
    await deleteDoc(docRef);
    // const ref = await fireStoreDB
    //   .collection(collection)
    //   .where("Opportunity_ID", "==", id);
    // ref.get().then(function (querySnapshot) {
    //   querySnapshot.forEach(function (doc) {
    //     doc.ref.delete();
    //   });
    // });
  }

  // async collectionPostRequest(collection: string, items: {}) {
  //   await fireStoreDB.collection(collection).add(items);
  // }

  async collectionFindByIDRequest(col: string, docId: string): Promise<any> {
    const docRef = doc(firestoreDB, col, docId);
    const ref = await getDoc(docRef);
    return { ...ref.data(), docId: ref.id };
    // const ref = await fireStoreDB
    //   .collection(collection)
    //   .where("ID", "==", id)
    //   .get();
    // const docs = ref.docs.map((doc) => doc.data());
    // return docs[0];
  }

  async collectionAll(col: string) {
    const colRef = collection(firestoreDB, col);
    const q = query(colRef, orderBy('createdAt', 'desc'), limit(8));
    const ref = await getDocs(q);
    const data: any = [];
    ref.docs.map((doc) => data.push({ ...doc.data(), docId: doc.id }));
    return data;
    // const ref = await fireStoreDB
    //   .collection(collection)
    //   .orderBy("createdAt", "desc")
    //   .limit(8)
    //   .get();
    // return ref.docs.map((doc) => doc.data());
  }
}
